var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { title: "Remove contractor from Talent Directory" },
    on: { close: _vm.closeModal, submit: _vm.submit },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "h-20 mb-5" },
                  [
                    _c("LoadingOverlay", {
                      attrs: {
                        loading: _vm.isLoading,
                        hasData: _vm.isContractorDataLoaded,
                        spinnerCentered: "",
                      },
                    }),
                  ],
                  1
                )
              : _c("div", [
                  _vm.isContractorDataEmpty
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "flex justify-center items-center text-lg h-20 mb-5",
                        },
                        [
                          _c("span", { staticClass: "font-bold mr-1" }, [
                            _vm._v(" " + _vm._s(_vm.contractorFullName) + " "),
                          ]),
                          _vm._v(" will be removed from the company "),
                        ]
                      )
                    : _c("div", [
                        _c("h4", { staticClass: "mb-2 font-bold" }, [
                          _vm._v(_vm._s(_vm.contractorFullName) + " has:"),
                        ]),
                        _c(
                          "ul",
                          { staticClass: "mb-3 pl-4 list-disc" },
                          [
                            _vm.isProjectsExist
                              ? _c(
                                  "li",
                                  [
                                    _c("RemoveListItem", {
                                      staticClass: "mb-1",
                                      attrs: {
                                        title: _vm.projectsListTitle,
                                        routeName:
                                          _vm.routeNames.MANAGE_PROJECTS,
                                        routeQuery: {
                                          contractors: _vm.contractorData.id,
                                        },
                                      },
                                      on: { clicked: _vm.closeModal },
                                    }),
                                    _c(
                                      "ul",
                                      { staticClass: "inner_list pl-6" },
                                      _vm._l(
                                        _vm.contractorData.projects,
                                        function (project) {
                                          return _c("RemoveListItem", {
                                            key: project.id,
                                            staticClass: "mb-1 text-low",
                                            attrs: {
                                              title:
                                                _vm.getProjectContent(project),
                                              routeName:
                                                _vm.routeNames.PROJECT_ACTIVITY,
                                              routeParams: { id: project.id },
                                            },
                                            on: { clicked: _vm.closeModal },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.isManagersHasAccess
                              ? _c("RemoveListItem", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    title: "Manager’s access",
                                    count: _vm.contractorData.managersCount,
                                    routeName:
                                      _vm.routeNames
                                        .CONTRACTOR_DETAILS_MANAGERS,
                                  },
                                  on: { clicked: _vm.closeModal },
                                })
                              : _vm._e(),
                            _vm.isDocumentsAttached
                              ? _c("RemoveListItem", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    title: "Attached documents",
                                    count: _vm.contractorData.documentsCount,
                                    routeName:
                                      _vm.routeNames
                                        .CONTRACTOR_DETAILS_DOCUMENTS,
                                  },
                                  on: { clicked: _vm.closeModal },
                                })
                              : _vm._e(),
                            _vm.isTeamMember
                              ? _c("RemoveListItem", {
                                  staticClass: "mb-2",
                                  attrs: {
                                    title: "Group memberships",
                                    count: _vm.contractorData.teamsCount,
                                    routeName: _vm.routeNames.MANAGE_TEAMS,
                                    routeQuery: {
                                      contractors: _vm.contractorData.id,
                                    },
                                  },
                                  on: { clicked: _vm.closeModal },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("p", { staticClass: "mb-1 text-low" }, [
                          _vm._v(
                            "The above items will not be removed. These will remain in the system after you have removed the contractor."
                          ),
                        ]),
                      ]),
                ]),
            _c(
              "div",
              { staticClass: "relative mb-5" },
              [_c("ModalSectionsDivider")],
              1
            ),
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c("UiButton", {
                  staticClass: "mr-3",
                  attrs: { variant: "outline", buttonText: "Cancel" },
                  on: { click: _vm.closeModal },
                }),
                _c("UiButton", {
                  staticClass: "mr-3",
                  attrs: {
                    buttonText: "Remove",
                    type: "submit",
                    disabled: _vm.isLoading,
                    processing: _vm.processing,
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }